import { axiosInstance } from '../helpers/axios';
const data = promise => promise.then(response => response.data);
export const studioService = {
  list: () => data(axiosInstance.get('/learning/studio/lessons')),
  get: id => data(axiosInstance.get('/learning/studio/lessons/' + id)),
  create: (id, content) => data(axiosInstance.post('/learning/studio/lessons', { id, content })),
  save: (id, draftRevision, content) => data(axiosInstance.put('/learning/studio/lessons/' + id, { draftRevision, content })),
  publish: (id, draftRevision) => data(axiosInstance.post('/learning/studio/lessons/' + id + '/publish', { draftRevision })),
  assets: () => data(axiosInstance.get('/learning/studio/assets')),
  teachers: () => data(axiosInstance.get('/learning/studio/teachers')),
  approveTeacher: username => data(axiosInstance.post('/learning/studio/teachers', { username })),
  revokeTeacher: id => data(axiosInstance.delete('/learning/studio/teachers/' + id)),
  catalog: () => data(axiosInstance.get('/learning/catalog')),
};
